import {Image, Link, RiverAccordion, Text} from '@primer/react-brand'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {AssetTypeEnum} from '../types'
import type {IconAssetLinkItem} from '../types'
import {AssetVideo} from './Video'
import {renderWithNoMarks} from '../utils'

export type FlexSuiteRiverAccordionProps = {
  items?: IconAssetLinkItem[]
}

export const FlexSuiteRiverAccordion = ({items}: FlexSuiteRiverAccordionProps) => {
  if (!items || items.length === 0) return null

  return (
    <>
      <RiverAccordion>
        {items.map(item => {
          const {
            heading,
            description,
            href,
            label,
            alt,
            assetType,
            optionImage,
            optionVideo,
            optionPoster,
            autoplay,
            videoSource,
          } = item.fields

          return (
            <RiverAccordion.Item key={item.sys.id}>
              <RiverAccordion.Heading as="h3">{renderWithNoMarks(heading)}</RiverAccordion.Heading>
              <RiverAccordion.Content>
                {description && <Text>{renderWithNoMarks(description)}</Text>}
                {href && label ? (
                  <Link href={href} {...(alt ? {'aria-label': alt} : {})}>
                    {label}
                  </Link>
                ) : null}
              </RiverAccordion.Content>
              <RiverAccordion.Visual>
                {assetType === AssetTypeEnum.enum.Image && optionImage && (
                  <Image
                    as="picture"
                    src={`${optionImage.fields.file.url}?fm=webp`}
                    sources={getImageSources(optionImage.fields.file.url, {maxWidth: 720})}
                    alt={optionImage.fields.description ?? ''}
                  />
                )}
                <AssetVideo
                  assetType={assetType}
                  optionVideo={optionVideo}
                  optionPoster={optionPoster}
                  autoplay={autoplay}
                  videoSource={videoSource}
                />
              </RiverAccordion.Visual>
            </RiverAccordion.Item>
          )
        })}
      </RiverAccordion>
    </>
  )
}
